module.exports = __webpack_public_path__ + "static/media/crm.3f7c5706.JPG";